import authService from "./authService";

const portalsRoutes = {
  Applicant: {
    name: "Applicants",
    secondery: "To the secured submission portal",
    route: "/applicantsportal",
  },
  Advisor: {
    name: "Advisors",
    secondery: "To the secured advisor's portal",
    route: "/advisors",
  },
  Referee: {
    name: "Reviewers ",
    secondery: "To the secured reviewer’s portal",
    route: "/referee",
  },
  Institution: {
    name: "Research Authority",
    secondery: "To the secured RA’s portal",
    route: "/researchauthorities",
  },
};

export async function GetPortalsNavigations() {
  const roles = await authService.getPortals();
  const portals = roles.map((r) => portalsRoutes[r]);
  return portals;
  //return Object.values(portalsRoutes);
}
